import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Security,
  People,
  ArrowBack,
} from '@mui/icons-material';

import GeneralSettings from './GeneralSettings';
import IPManagement from './IPManagement';
import UserManagement from './UserManagement';

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ py: 3 }}>{children}</Box>;
}

export default function SettingsPage({ onBack }) {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Tooltip title="Torna al file manager">
          <IconButton onClick={onBack}>
            <ArrowBack />
          </IconButton>
        </Tooltip>
        <Typography variant="h5" fontWeight={600}>
          Impostazioni
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{ border: 1, borderColor: 'divider', borderRadius: 2 }}
      >
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
        >
          <Tab icon={<SettingsIcon />} iconPosition="start" label="Generale" />
          <Tab icon={<Security />} iconPosition="start" label="Sicurezza" />
          <Tab icon={<People />} iconPosition="start" label="Utenti" />
        </Tabs>

        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <TabPanel value={tab} index={0}>
            <GeneralSettings />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <IPManagement />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <UserManagement />
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  );
}
